// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1xrvJ","modalFooterButton":"ModalNotes_modalFooterButton__VB_V7"};